module.exports = __webpack_public_path__ + "img/close.445946c3.png";